import { render, staticRenderFns } from "./InspectionSummaryReport.vue?vue&type=template&id=9615fcb6&"
import script from "./InspectionSummaryReport.vue?vue&type=script&lang=js&"
export * from "./InspectionSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports